<div class="w-[30vw] h-[40vh]">
  @if (!createDocumentForm.value.base64Data) {
    <p-fileupload [style]="{'background-color':'#27272a','border-color':'#52525b'}"
      (uploadHandler)="addImage($event)"
      mode="advanced"
      [auto]="true"
      [customUpload]="true"
      [multiple]="false"
      [accept]="determinePossibleMimeTypes()"
      maxFileSize="524288000"
      [chooseLabel]="'FileUpload.Choose'|translate">
      <ng-template #header let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
        let-uploadCallback="uploadCallback">
        <div class="flex justify-center items-center w-full">
          <p-button size="large" label="{{'CreateDocument.UploadDocument'|translate}}"
          (onClick)=chooseCallback()></p-button>
        </div>
      </ng-template>
      <ng-template #empty>
        <div class="flex items-center justify-center flex-col mt-4">
          <i class="pi pi-cloud-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"></i>
          <p class="mt-6 mb-0">{{ 'CreateDocument.DragAndDrop'|translate }}</p>
        </div>
      </ng-template>
    </p-fileupload>
  }
  @if (createDocumentForm.value.base64Data) {
    <form class="flex flex-col justify-center items-center" [formGroup]="createDocumentForm">
      <div class="w-[30vw] h-[25vh] flex flex-col justify-center items-center">
        @if (createDocumentForm.value.documentType=='Image') {
          <img class="max-w-[100%] max-h-[100%]"
            [src]="'data:'+createDocumentForm.value.mimeType+';base64,'+createDocumentForm.value.base64Data"/>
          }
          @if (createDocumentForm.value.documentType=='Document') {
            <object class="w-[100%] h-[100%]" [data]="sanitizeResourceString('data:application/pdf;base64,'+createDocumentForm.value.base64Data)"></object>
          }
        </div>
        <div class="h-[15vh] w-[100%]">
          <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Filename'|translate }}</div>
          <input id="race" type="text" variant="filled" fluid="true" pInputText pSize="large"
            formControlName="filename"/>
            <div class="pt-4 flex flex-row justify-between items-center">
              <div>
                @if(routingData.sourcePage!="treatment-detail"&&!routingData.isSkeleton){
                <p-checkbox inputId="isPinned" formControlName="isPinned" [binary]="true"/>
                <label for="isPinned" class="ml-2">{{ 'Document.ShouldBePinned'|translate }}</label>
                }
              </div>
              <div class="flex gap-2">
                <p-button type="submit" size="large" [disabled]="!createDocumentForm.valid"
                  label="{{'CreateDocument.Save'|translate}}" (onClick)="onSubmit(false)"/>
                  @if (createDocumentForm.value.documentType=='Image') {
                    @if (routingData.documentType=='Image') {
                      <p-button type="submit" size="large" [disabled]="!createDocumentForm.valid"
                        label="{{'CreateDocument.Annotate'|translate}}" (onClick)="onSubmit(true)"/>
                    }
                  }
                </div>
              </div>
            </div>
          </form>
        }
      </div>
